import Dashboard from "../../components/Lawyers/DashboardMain";

export default function Lawyer() {
  return (
      <Dashboard />   
  );
}
